module.exports = {"TXTCLI_About_you":{"id":"TXTCLI_About_you","defaultMessage":"あなたについて教えてください"}}